module.exports = __webpack_public_path__ + "static/img/img6.4f39cfa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/help/img6.png
// module id = nfmF
// module chunks = 1